import { type OpenApiSchemaMediaItemV2, type OpenApiSchemaVideo } from '../../../../api/schema';

export const VIDEO_STATUS_PROCESSING: OpenApiSchemaVideo['status'] = 'processing';
export const VIDEO_STATUS_READY: OpenApiSchemaVideo['status'] = 'ready';

export const VIDEO_STATUS_INITIAL: OpenApiSchemaVideo['status'] = VIDEO_STATUS_PROCESSING;

export const VIDEO_STATUSES_SHOW_LOADER: OpenApiSchemaVideo['status'][] = [
    VIDEO_STATUS_PROCESSING,
    'wait_uploading',
    'uploaded',
];

export const VIDEO_STATUSES_SHOW_ERROR: OpenApiSchemaVideo['status'][] = [
    'upload_failed',
    'error',
    'video_status_unspecified',
];

export const MEDIA_TYPE_VIDEO = 'VIDEO' satisfies OpenApiSchemaMediaItemV2['type'];
